import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";


export default function AddCardToCollectionSelects({open, handleClose, id, name}) {

//    const {items: cards} = useSelector((state) => state.cardReducer)

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Adding a Card to Your Collection</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography>{name}</Typography>
                </DialogContentText>
                <Typography>To include a single card in your collection, begin by inputting its name in the primary search engine. This will guide you to the card's dedicated page. Once there, select the card's edition. Lastly, proceed by clicking the "Add a card to collection" button. In no time, your collection will start to grow!</Typography>
            </DialogContent>
                {/* <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={cards}
                    getOptionLabel={(option) => !!option.name ? option.name : option}
                    sx={{width: 300}}
                    renderInput={(params) => <TextField {...params} label="Card Name"/>}
                />
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={cards}
                    getOptionLabel={(option) => !!option.name ? option.name : option}
                    sx={{width: 300}}
                    renderInput={(params) => <TextField {...params} label="Set"/>}
                />
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={cards}
                    getOptionLabel={(option) => !!option.name ? option.name : option}
                    sx={{width: 300}}
                    renderInput={(params) => <TextField {...params} label="Language"/>}
                /> */}
        </Dialog>
    )
}
